import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class MergeOrderZendeskTicketArgs extends ActionArgs {
  @Field(() => String)
  orderId: string

  @Field(() => String)
  sourceTicketId: string

  @Field(() => String)
  targetTicketId: string
}
